import React from 'react';
import Svg from '../Svg';

import { IconProps } from '../icon';

export const Edit16 = ({
  accessibilityLabel,
  contrast,
  className,
}: IconProps) => (
  <Svg
    accessibilityLabel={accessibilityLabel}
    size={16}
    contrast={contrast}
    className={className}
  >
    <g clipPath='url(#clip0_1_329)'>
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M12.3838 1.32321C11.8956 0.835054 11.1042 0.835053 10.616 1.32321L1.82268 10.1165L0.82282 14.116C0.662612 14.7568 1.24308 15.3373 1.88391 15.1771L5.88334 14.1772L14.6767 5.38387C15.1648 4.89571 15.1648 4.10426 14.6767 3.6161L12.3838 1.32321ZM10.0606 3.99991L11.4999 2.56065L13.4392 4.49999L12 5.93925L10.0606 3.99991ZM8.99997 5.06057L3.17712 10.8834L2.53068 13.4692L5.11646 12.8228L10.9393 6.99991L8.99997 5.06057Z'
        fill='currentColor'
      />
    </g>
    <defs>
      <clipPath id='clip0_1_329'>
        <rect width='16' height='16' fill='white' />
      </clipPath>
    </defs>
  </Svg>
);

Edit16.displayName = 'Edit16';
export default Edit16;
